// *** 샤크라, 파이어베이스 디펜던시 없이 구현된 것만 구현 *** (별도 디펜던시 존재시 별도 유틸로 분리)
import { t } from 'i18next';
import i18n from '../translation/i18n';
import { useNavigate } from "react-router-dom";
import { useEffect, useRef, useState } from 'react';
import { useRecoilState } from 'recoil';

export const BrowserType = {
  SAMSUNG: {name: "SAMSUNG", userAgentRegex: /SamsungBrowser/i, isSupported: false},
  LINE: {name: "LINE", userAgentRegex: /Line/i, isSupported: false},
  CHROME: {name: "CHROME", userAgentRegex: /chrome|chromium|crios/i, isSupported: true},
  FIREFOX: {name: "FIREFOX", userAgentRegex: /firefox|fxios/i, isSupported: false},
  SAFARI: {name: "SAFARI", userAgentRegex: /safari/i, isSupported: true},
  OPERA: {name: "OPERA", userAgentRegex: /opr\//i, isSupported: false},
  EDGE: {name: "EDGE", userAgentRegex: /edg/i, isSupported: false},
  // TODO : 추가대응
}
Object.freeze(BrowserType);

/**
 * 현재 BrowserType 조회
 * @returns BrowserType
 */
export function getCurrentBrowserType() {
  for (const [k, v] of Object.entries(BrowserType)) {
    if (navigator.userAgent.match(v.userAgentRegex)) {
      return BrowserType[k];
    }
  }
  return null;
}

/**
 * 지원 가능한 브라우저인가 판별
 * @returns boolean
 */
export function isSupportedBrowser() {
  const t = getCurrentBrowserType();
  if (!isBlank(t)) {
    return t.isSupported;
  }
  return true;
}

export function dataURItoBlob(dataURI) {
  // convert base64/URLEncoded data component to raw binary data held in a string
  var byteString;
  if (dataURI.split(',')[0].indexOf('base64') >= 0)
      byteString = atob(dataURI.split(',')[1]);
  else
      byteString = unescape(dataURI.split(',')[1]);

  // separate out the mime component
  var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

  // write the bytes of the string to a typed array
  var ia = new Uint8Array(byteString.length);
  for (var i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
  }

  return new Blob([ia], {type:mimeString});
}

export const convertURLtoFile = async (url) => {
  const response = await fetch(url);
  const data = await response.blob();
  // const ext = url.split(".").pop();
  const filename = 'jjal.png';
  // const metadata = { type: `image/${ext}` };
  // return new File([data], filename, metadata);
  return new File([data], filename);
};

export function HexToRGB(hex) {
    var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    hex = hex.replace(shorthandRegex, function(m, r, g, b) {
      return r + r + g + g + b + b;
    });
  
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16)
    } : null;
}
  
// RGBToHex
export function RGBToHex(red, green, blue) {
    return "#" + ColorToHex(red) + ColorToHex(green) + ColorToHex(blue);
}

function ColorToHex(color) {
    const hexadecimal = color.toString(16);
    return hexadecimal.length === 1 ? "0" + hexadecimal: hexadecimal;
}

export function nextInt(to) {
  return randomInt(0,to);
}
export function randomInt(from, to) {
  return Math.floor((Math.random() * to) + from);
}
export function getCurrentLangCode() {
  // ko-KR => ko 로 국가코드 발라내고 언어코드만 남기기
  let language = i18n.language;
  let idxSlash = language.indexOf("-");
  if (idxSlash > 0) {
    language = language.slice(0, idxSlash);
  }
  let idxUnderbar = language.indexOf("_");
  if (idxUnderbar > 0) {
    language = language.slice(0, idxUnderbar);
  }
  let langCode = getLangCode(language);
  if (isBlank(langCode)) {
    return LangCode.en;
  }
  return langCode;
}

export function getCurrentLangText() {
  let langCode = getCurrentLangCode();
  if (langCode === LangCode.ko)
    return 'KO'
  else if (langCode === LangCode.ja)
    return 'JA'
  else
    return 'EN'
}

export function getCurrentLangTextLong() {
  let langCode = getCurrentLangCode();
  if (langCode === LangCode.ko)
    return '한국어'
  else if (langCode === LangCode.ja)
    return '日本語'
  else
    return 'ENGLISH'
}

export const getPathFromItemCode = (itemCode) => {
  let indexOf = itemCode.indexOf('_');
  let path = './images/thumb/' + itemCode;
  if(indexOf === -1) {
      path = path + '.jpeg' 
  } else {
      path = path + '.jpg';
  }
  return path;
}

/**
 * 값이 비어있는지 여부
 * @param {*} value 
 * @returns 
 */
export function isBlank(value) {
  return value === undefined || value === null || value === "";
}

/**
 * 값이 비어있지 않다면 그대로 반환하고, 비어있다면 defaultValue 반환
 * @param {*} value 
 * @param {*} defaultValue 
 * @returns 
 */
export function getDefaultIfBlank(value, defaultValue) {
  if (isBlank(value)) {
    return defaultValue;
  }
  return value;
}

/**
 * 값이 비어있지 않다면 그대로 반환하고, 비어있다면 func 실행
 * @param {*} value 
 * @param {*} func 
 * @returns 
 */
export function getOrExecuteIfBlank(value, func) {
  if (isBlank(value)) {
    func();
  }
  return value;
}

/**
 * 값이 있고 true 인지 여부
 * @param {*} value 
 */
export function isBooleanTrue(value) {
  return !isBlank(value) && (value === true || value === "true");
}

/**
 * 값이 있고 false 인지 여부
 * @param {*} value 
 */
export function isBooleanFalse(value) {
  return !isBlank(value) && (value === false || value === "false");
}

/**
 * 빈 객체인지 여부
 * @param {*} value 
 * @returns 
 */
export function isEmptyObject(value) {
  return value?.constructor === Object && Object.keys(value).length === 0;
}

/**
 * array 인지 여부
 * @param {*} value 
 * @returns 
 */
export function isArray(value) {
  return !isBlank(value) && Array.isArray(value);
}

/**
 * function 인지 여부
 * @param {*} functionToCheck 
 * @returns 
 */
export function isFunction(functionToCheck) {
  return functionToCheck && {}.toString.call(functionToCheck) === '[object Function]';
}

/**
 * 
 * @param {*} expected 
 * @param {*} actual 
 * @returns 
 */
export function isEqual(expected, actual) {
  const expectedValue = getDefaultIfBlank(expected, null);
  const actualValue = getDefaultIfBlank(actual, null);
  if (expectedValue !== null && actualValue !== null) {
    return expectedValue === actualValue;
  } else if (expectedValue === null && actualValue === null) {
    return true;
  } else {
    return false;
  }
}

/**
 * 쿼리스트링 => 오브젝트 변환
 * (ex) "signup=true&promotionCode=dec2022" => {signup: true, promotionCode: "dec2022"}
 * @param {*} queryString 
 * @returns 
 */
export function convertQueryStringToObject(queryString) {
  let obj = {}
  if (!isBlank(queryString)) {
    let query = queryString;
    if (queryString.startsWith('?')) {
      query = queryString.substring(1);
    }
    let arr = query.split('&');
    for (let i = 0; i < arr.length; i++) {
      const pair = arr[i].split('=');
      obj[pair[0]] = pair[1];
    }
  }
  return obj;
}

/**
 * 오브젝트 => 쿼리스트링 변환
 * (ex) {signup: true, promotionCode: "dec2022"} => "signup=true&promotionCode=dec2022"
 * @param {*} o 
 * @returns 
 */
export function convertObjectToQueryString(o) {
  let str = '';
  if (!isBlank(o)) {
    let notEmptyValueCnt = 0;
    for (const k in o) {
      const v = o[k];
      if (isBlank(v)) {
        continue;
      }
      if (notEmptyValueCnt > 0) {
        str += '&';
      }
      str += `${k}=${v}`;
      notEmptyValueCnt++;

    }
  }
  return str;
}

export function ignoreError(func) {
  try {
    return func();
  } catch (e) {
    console.error(e);
  }
  return null;
}

/**
 * date -> yyyy mm dd 문자열 포멧팅
 * @param {*} date 
 * @param {*} separator 
 * @returns 
 */
export function formatDateToyyyyMMdd(date, separator) {
  let d = new Date(date);
  let month = '' + (d.getMonth() + 1);
  let day = '' + d.getDate();
  let year = d.getFullYear();

  if (month.length < 2) 
      month = '0' + month;
  if (day.length < 2) 
      day = '0' + day;

  return [year, month, day].join(separator);
}

/**
 * date -> yyyy mm dd 문자열 포멧팅
 * @param {*} date 
 * @param {*} separator 
 * @returns 
 */
 export function formatDateToyyyyMMddHHmmSS(date, separator) {
  let d = new Date(date);
  let month = '' + (d.getMonth() + 1);
  let day = '' + d.getDate();
  let year = d.getFullYear();
  let hours = ('0' + d.getHours()).slice(-2); 
  let minutes = ('0' + d.getMinutes()).slice(-2);
  let seconds = ('0' + d.getSeconds()).slice(-2); 

  if (month.length < 2) 
      month = '0' + month;
  if (day.length < 2) 
      day = '0' + day;

  return [[year, month, day].join(separator), (hours + ':' + minutes  + ':' + seconds)];
}

/**
 * date -> yyyy mm dd 문자열 포멧팅
 * @param {*} date 
 * @param {*} separator 
 * @returns 
 */
 export function formatDateToHHmm(date) {
  let d = new Date(date);
  // let month = '' + (d.getMonth() + 1);
  // let day = '' + d.getDate();
  // let year = d.getFullYear();
  let hours = ('0' + d.getHours()).slice(-2); 
  let minutes = ('0' + d.getMinutes()).slice(-2);
  // let seconds = ('0' + d.getSeconds()).slice(-2); 

  // if (month.length < 2) 
  //     month = '0' + month;
  // if (day.length < 2) 
  //     day = '0' + day;

  return (hours + ':' + minutes);
}

/**
 * date -> 등록후 시간 계산
 * @param {*} date 
 * @returns 
 */
 export function elapsedTime(date) {
  const start = new Date(date);
  const end = new Date(); // 현재 날짜
  
  const diff = (end - start); // 경과 시간
 
  const times = [
    {time: t('mya18050'), milliSeconds: 1000 * 60},
    {time: t('mya18051'), milliSeconds: 1000 * 60 * 60},
    {time: t('mya18052'), milliSeconds: 1000 * 60 * 60 * 24},
    {time: t('mya18053'), milliSeconds: 1000 * 60 * 60 * 24 * 30},
    {time: t('mya18054'), milliSeconds: 1000 * 60 * 60 * 24 * 365},
  ].reverse();
  
  // 년 단위부터 알맞는 단위 찾기
  for (const value of times) {
    const betweenTime = Math.floor(diff / value.milliSeconds);
  
    // 큰 단위는 0보다 작은 소수 단위 나옴
    if (betweenTime > 0) {
      return `${betweenTime}${value.time}`
      //  + t('mya18055')
       ;
    }
  }
  
  // 모든 단위가 맞지 않을 시
  return t('mya18056');
}

/**
 * KST Date -> GMT 변환
 * @param {*} kstDate 
 * @returns 
 */
export function convertKstDateToGmt(kstDate) {
  if (isBlank(kstDate)) {
    return null;
  }
  return new Date(kstDate.getTime() - 1000 * 60 * 60 * 9);
}
/**
 * KST timestamp (밀리초) -> GMT 변환
 * @param {*} kstMillis 
 * @returns 
 */
 export function convertKstMillisToGmt(kstMillis) {
  if (isBlank(kstMillis)) {
    return null;
  }
  return new Date(kstMillis - 1000 * 60 * 60 * 9);
}

/**
 * GMT timestamp (밀리초) -> KST 변환
 * @param {*} gmtMillis
 * @returns 
 */
 export function convertGmtMillisToKst(gmtMillis) {
  if (isBlank(gmtMillis)) {
    return null;
  }
  return new Date(gmtMillis + 1000 * 60 * 60 * 9);
}

/**
 * 파일명 확장자 제거해서 반환
 * ateez0.jpeg -> ateez0
 * @param {*} fileName 
 * @returns 
 */
export const getFileNameWithoutExtension = (fileName) => {
  let indexOfDot = fileName.indexOf('.');
  if (indexOfDot !== -1) {
    return fileName.substring(0, indexOfDot);
  }
  return fileName;
}

/**
 * 포카 종류
 * @author eren (서버코드와 맞춰서 관리중)
 */
export const PocaType = {
  QR: "QR",
  FREE: "FREE",
  MEMBERSHIP: "MEMBERSHIP",
}
Object.freeze(PocaType);

/**
 * 포카 필터 그룹
 * @author eren (서버데이터와 맞춰서 관리중)
 */
export const IdolContentFilterGroup = {
  qr: {name: "qr", description: "GUERRILLA 포카덱스 시리즈"},
  gift: {name: "gift", description: "FREE 포카덱스 시리즈"},
}
Object.freeze(IdolContentFilterGroup);

/**
 * groupName 으로 포카 필터 그룹 얻기
 * @param {*} groupName 
 * @returns 
 */
export const getIdolContentFilterGroup = (groupName) => {
  return IdolContentFilterGroup[groupName];
}

/**
 * 특전 게시판 미디어 타입
 * @author eren (서버코드와 맞춰서 관리중)
 */
export const BoardBenefitMediaType = {
  VIDEO: "VIDEO",
  IMAGE: "IMAGE",
}
Object.freeze(BoardBenefitMediaType);
export const getBoardBenefitMediaType = (str) => {
  return BoardBenefitMediaType[str];
}

/**
 * 게시판 정렬 타입
 * @author eren (서버코드와 맞춰서 관리중)
 */
export const BoardSortType = {
  CREATE_DESC : {translateCode: 'mya18023'}, // 최신순
  REACT_COUNT_DESC : {translateCode: 'mya18024'}, // 좋아요수 내림차순
  COMMENT_COUNT_DESC : {translateCode: 'mya18025'}, // 댓글수 내림차순
}
Object.freeze(BoardSortType);

/**
 * 닉네임 체크
 * @author eren (서버 로직도 이에 맞춰서 이중체크)
 * @param {*} v 
 * @returns 
 */
export function isValidNickname(v) {
  if (isBlank(v) || v.length < 4 || v.length > 12) {
    return false;
  }
  const reg = /[^\wㄱ-힣ぁ-ゔァ-ヴー]/g;
  if (reg.test(v)) {
      return false;
  }
  return true;
}

export const getEmailIfValidOrNull = (email) => {
  return (!isBlank(email) && email.match(/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{1,})+$/)) ? email : null;
}
export const getNicknameIfValidOrNull = (nickname) => {
  return isValidNickname(nickname) ? nickname : null;
}
export const getPasswordIfValidOrNull = (password) => {
  return (!isBlank(password) && password.match(/^.*(?=^.{6,24}$)(?=.*\d)(?=.*[a-zA-Z]).*$/)) ? password : null;
}

/**
 * 에이티즈 멤버
 * @author eren (서버코드와 맞춰서 관리중)
 * @param name
 * : 개발자구분용 이름 (개발자 enum 타입이름으로 활용)
 * @param nftNamePrefix
 * : nft 이름 prefix
 * @param translateCode
 * : 번역이 되는곳에서 노출되는 이름의 번역코드
 */
export const AteezMember = {
  HONGJOONG: {name:"HONGJOONG", nftNamePrefix:"HONG JOONG", translateCode:"mya18012"},
  SEONGHWA: {name:"SEONGHWA", nftNamePrefix:"SEONG HWA", translateCode:"mya18011"},
  YUNHO: {name:"YUNHO", nftNamePrefix:"YUN HO", translateCode:"mya18013"},
  YEOSANG: {name:"YEOSANG", nftNamePrefix:"YEO SANG", translateCode:"mya18014"},
  SAN: {name:"SAN", nftNamePrefix:"SAN", translateCode:"mya18015"},
  MINGI: {name:"MINGI", nftNamePrefix:"MIN GI", translateCode:"mya18016"},
  WOOYOUNG: {name:"WOOYOUNG", nftNamePrefix:"WOO YOUNG", translateCode:"mya18017"},
  JONGHO: {name:"JONGHO", nftNamePrefix:"JONG HO", translateCode:"mya18018"},
}
Object.freeze(AteezMember);

/**
 * 에이티즈 QR 이미지
 */
 export const AteezQrImage = {
  ateez0: {ateezMember: AteezMember.HONGJOONG, uniquePostfix: `(A)`},
  ateez1: {ateezMember: AteezMember.JONGHO, uniquePostfix: `(A)`},
  ateez2: {ateezMember: AteezMember.MINGI, uniquePostfix: `(A)`},
  ateez3: {ateezMember: AteezMember.SAN, uniquePostfix: `(A)`},
  ateez4: {ateezMember: AteezMember.SEONGHWA, uniquePostfix: `(A)`},
  ateez5: {ateezMember: AteezMember.WOOYOUNG, uniquePostfix: `(A)`},
  ateez6: {ateezMember: AteezMember.YUNHO, uniquePostfix: `(A)`},
  ateez7: {ateezMember: AteezMember.YEOSANG, uniquePostfix: `(A)`},
  ateez8: {ateezMember: AteezMember.HONGJOONG, uniquePostfix: `(B)`},
  ateez9: {ateezMember: AteezMember.JONGHO, uniquePostfix: `(B)`},
  ateez10: {ateezMember: AteezMember.MINGI, uniquePostfix: `(B)`},
  ateez11: {ateezMember: AteezMember.SAN, uniquePostfix: `(B)`},
  ateez12: {ateezMember: AteezMember.SEONGHWA, uniquePostfix: `(B)`},
  ateez13: {ateezMember: AteezMember.WOOYOUNG, uniquePostfix: `(B)`},
  ateez14: {ateezMember: AteezMember.YUNHO, uniquePostfix: `(B)`},
  ateez15: {ateezMember: AteezMember.YEOSANG, uniquePostfix: `(B)`},
}
Object.freeze(AteezQrImage);

/**
 * imageOrg -> AteezQrImage 조회
 * @param {*} imageOrg 
 * @returns 
 */
export const getAteezQrImage = (imageOrg) => {
  if (isBlank(imageOrg)) {
    return null;
  }
  let v = AteezQrImage[imageOrg];
  return isBlank(v) ? null : v;
}

/**
 * imageOrg -> AteezMember 조회
 * @param {*} imageOrg 
 * @returns 
 */
export const getAteezMemberByImageOrg = (imageOrg) => {
  let ateezQrImage = getAteezQrImage(imageOrg);
  if(isBlank(ateezQrImage)) {
    if(imageOrg.includes('freephotocard_hj'))
      return AteezMember.HONGJOONG
    if(imageOrg.includes('freephotocard_jh'))
      return AteezMember.JONGHO
    if(imageOrg.includes('freephotocard_mg'))
      return AteezMember.MINGI
    if(imageOrg.includes('freephotocard_sa'))
      return AteezMember.SAN
    if(imageOrg.includes('freephotocard_sh'))
      return AteezMember.SEONGHWA
    if(imageOrg.includes('freephotocard_wy'))
      return AteezMember.WOOYOUNG
    if(imageOrg.includes('freephotocard_yh'))
      return AteezMember.YUNHO
    if(imageOrg.includes('freephotocard_ys'))
      return AteezMember.YEOSANG
    return null;
  } 
  return ateezQrImage.ateezMember;
}

/**
 * imageOrg -> nft 이름 가져오기
 * ex. HONG JOONG (A)
 * 
 * @param {*} imageOrg 
 * @returns 
 */
export const getAteezQrImageUniqueNameByImageOrg = (imageOrg) => {
  let ateezQrImage = getAteezQrImage(imageOrg);
  return isBlank(ateezQrImage) ? null : `${ateezQrImage.ateezMember.nftNamePrefix} ${ateezQrImage.uniquePostfix}`;
}

export const AteezFreeCode = {
  freephotocard: {ateezMember: null, name: "freephotocard"},
  freephotocard_hj_1: {ateezMember: AteezMember.HONGJOONG, name: "freephotocard_hj_1"},
  freephotocard_jh_1: {ateezMember: AteezMember.JONGHO, name: "freephotocard_jh_1"},
  freephotocard_mg_1: {ateezMember: AteezMember.MINGI, name: "freephotocard_mg_1"},
  freephotocard_sa_1: {ateezMember: AteezMember.SAN, name: "freephotocard_sa_1"},
  freephotocard_sh_1: {ateezMember: AteezMember.SEONGHWA, name: "freephotocard_sh_1"},
  freephotocard_wy_1: {ateezMember: AteezMember.WOOYOUNG, name: "freephotocard_wy_1"},
  freephotocard_yh_1: {ateezMember: AteezMember.YUNHO, name: "freephotocard_yh_1"},
  freephotocard_ys_1: {ateezMember: AteezMember.YEOSANG, name: "freephotocard_ys_1"},
  freephotocard_hj_2: {ateezMember: AteezMember.HONGJOONG, name: "freephotocard_hj_2"},
  freephotocard_jh_2: {ateezMember: AteezMember.JONGHO, name: "freephotocard_jh_2"},
  freephotocard_mg_2: {ateezMember: AteezMember.MINGI, name: "freephotocard_mg_2"},
  freephotocard_sa_2: {ateezMember: AteezMember.SAN, name: "freephotocard_sa_2"},
  freephotocard_sh_2: {ateezMember: AteezMember.SEONGHWA, name: "freephotocard_sh_2"},
  freephotocard_wy_2: {ateezMember: AteezMember.WOOYOUNG, name: "freephotocard_wy_2"},
  freephotocard_yh_2: {ateezMember: AteezMember.YUNHO, name: "freephotocard_yh_2"},
  freephotocard_ys_2: {ateezMember: AteezMember.YEOSANG, name: "freephotocard_ys_2"},
}
Object.freeze(AteezFreeCode);

/**
 * code -> AteezFreeCode 조회
 * @param {*} code 
 * @returns 
 */
export const getAteezFreeCode = (code) => {
  if (isBlank(code)) {
    return null;
  }
  // 무료포카중에 뒤에 확장자 붙은게 있음..
  let codeWithoutExtension = getFileNameWithoutExtension(code);
  let v = AteezFreeCode[codeWithoutExtension];
  return isBlank(v) ? null : v;
}

/**
 * code -> AteezMember 조회
 * @param {*} code 
 * @returns 
 */
export const getAteezMemberByCode = (code) => {
  let ateezFreeCode = getAteezFreeCode(code);
  return isBlank(ateezFreeCode) ? null : ateezFreeCode.ateezMember;
}

/**
 * 뽐내기 멤버 필터 이름 가져오기
 * @param {*} code 
 * @param {*} imageOrg 
 * @returns 
 */
export const getAteezMemberFilter = (code, imageOrg) => {
  let ateezMemberByImageOrg = getAteezMemberByImageOrg(imageOrg);
  if (!isBlank(ateezMemberByImageOrg)) {
      return ateezMemberByImageOrg.name;
  }
  let ateezMemberByCode = getAteezMemberByCode(code);
  if (!isBlank(ateezMemberByCode)) {
      return ateezMemberByCode.name;
  }
  return null;
}

export const membershipNftCardData = {
  // createAt: 1664855469000,
  nftImageUrl: "/images/kauramembership.png",
  nftName: t('my5023'),
  nftThumbImageUrl: "/images/kauramembership.png",
  paperCategory: "POCA",
  paperId: -1,
  pocaType: "MEMBERSHIP",
  // isEvent: true,
}

/**
 * 회원가입시 주는 기본 NFT qr code
 */
export const MEMBERSHIP_CODE = "nftmembership";

/**
 * 회원가입시 주는 기본 포토카드
 */
export const FREEPHOTOCARD_CODE = "freephotocard";

/**
 * 앨범구매 마켓 주소
 * - 비트로드
 */
export const MARKET_URL = 'https://beatroad.co.kr/product/detail.html?product_no=4267&cate_no=42&display_group=1';

/**
 * 앨범구매 마켓으로 이동
 */
export const moveToMarket = () => {
  window.open(MARKET_URL);
}

/**
 * 언어 코드
 */
export const LangCode = {
  ko: "ko",
  en: "en",
  ja: "ja",
}
Object.freeze(LangCode);
export const getLangCode = (langCode) => {
  return LangCode[langCode];
}

/**
 * 유저 롤 타입
 * @author eren (서버코드와 맞춰서 관리중)
 */
export const UserRoleType = {
  GUEST: "GUEST",
  MEMBER: "MEMBER",
  QR_DONE: "QR_DONE",
  NFT_DONE: "NFT_DONE",
  ADMIN: "ADMIN",
}
Object.freeze(UserRoleType);

/**
 * 게시물 카테고리 타입
 * 유저 롤 타입
 * @author eren (서버코드와 맞춰서 관리중)
 */
export const BoardCategory = {
  NOTICE: "NOTICE",
  FAQ: "FAQ",
  FORYOU: "FORYOU", // for you 게시판
  BOAST: "뽐내기",
}
Object.freeze(BoardCategory);

/**
 * NFT 상태
 * @author eren (서버코드와 맞춰서 관리중)
 */
export const PocaNftState = {
  // 서버가 블록체인 네트워크에 NFT 민팅요청을 한 상태
  WAITING: "WAITING",
  // 블록체인 네트워크가 NFT 민팅중인 상태
  RUNNING: "RUNNING",
  // 블록체인 네트워크가 NFT 민팅을 완료한 상태
  COMPLETED: "COMPLETED",
  // 블록체인 네트워크가 NFT 민팅을 실패한 상태
  FAILED: "FAILED",
}
Object.freeze(PocaNftState);

export const getApiUrl = ()=>{
  if(process.env.REACT_APP_KAURA_API.includes("http://"))
    return process.env.REACT_APP_KAURA_API;
  return "https://" + process.env.REACT_APP_KAURA_API;
}

export const ckEditorConfig = {
  toolbar: [
      { name: "tools", items: ["Maximize"] },
      { name: "document", items: ["Source"] },
      { name: "styles", items: ["Format", "Font", "FontSize"] },
      // {name: "clipboard", items: ["Cut", "Copy", "Paste", "PasteText"]},
      {name: "basicstyles", items: [
              "Bold",
              "Italic",
              "Underline",
              "Strike",
              // "-",
              // "Subscript",
              // "Superscript"
          ]
      },
      {name: "paragraph", items: [
              "NumberedList",
              "BulletedList",
              "-",
              "Outdent",
              "Indent",
          ]
      },
      {name: "align", items: [
              "JustifyLeft",
              "JustifyCenter",
              "JustifyRight",
              "JustifyBlock"
          ]
      },
      { name: "colors", items: ["TextColor", "BGColor"] },
      { name: "links", items: ["Link", "Unlink"] },
      { name: "insert", items: ["Image", "Table", "HorizontalRule"] },
      "/",
  ],
  extraPlugins: "colorbutton, colordialog, font, justify",
  removeButtons: "",
  allowedContent: true
  // filebrowserUploadMethod: "form",
  // filebrowserUploadUrl :('/upload'),
};

export const ckEditorFromAteezConfig = {
  toolbar: [
      //{ name: "tools", items: ["Maximize"] },
      { name: "document", items: ["Source"] },
      { name: "styles", items: ["Format", "Font", "FontSize"] },
      // {name: "clipboard", items: ["Cut", "Copy", "Paste", "PasteText"]},
      {name: "basicstyles", items: [
              "Bold",
              "Italic",
              "Underline",
              "Strike",
              // "-",
              // "Subscript",
              // "Superscript"
          ]
      },
      // {name: "paragraph", items: [
      //         "NumberedList",
      //         "BulletedList",
      //         "-",
      //         "Outdent",
      //         "Indent",
      //     ]
      // },
      {name: "align", items: [
              "JustifyLeft",
              "JustifyCenter",
              "JustifyRight",
              "JustifyBlock"
          ]
      },
      { name: "colors", items: ["TextColor", "BGColor"] },
      { name: "links", items: ["Link", "Unlink"] },
      //{ name: "insert", items: ["Image", "Table", "HorizontalRule"] },
      "/",
  ],
  extraPlugins: "colorbutton, colordialog, font, justify",
  removeButtons: "",
  // filebrowserUploadMethod: "form",
  // filebrowserUploadUrl :('/upload'),
};

/**
 * 
 * @param {string} imageOrg 
 */
// [2022.10.26] eren. 원본이미지, lazy loading 용 이미지 서버에서 풀 패스 응답해줌. (/images/thumb/freephotocard_sh_2.jpg, /images/small/freephotocard_sh_2.jpg)
/*export const getImgPath = (imageOrg, extName, small) => {
  if(imageOrg.includes("http://") || imageOrg.includes("https://")){
    if(small === true)
      return 'images/small/'+imageOrg.split('0_FreeCards%2F')[1];
    return imageOrg;
  }

  // 22.10.17 확장자가 없을 경우에만 하드코딩 추가
  var ext = '';
  if(imageOrg.lastIndexOf('.') === -1) {
    ext = extName;
  }

  if(small === true)
    return '/images/small/' + imageOrg + ext;

  return '/images/' + imageOrg + ext;
}*/

// [2022.10.26] eren. 원본이미지 서버에서 풀 패스 응답해줌. (/images/thumb/freephotocard_sh_2.jpg)
/*export const getImgThumbPath = (imageOrg, extName) => {
  if(imageOrg.includes("http://") || imageOrg.includes("https://")){
      return 'images/thumb/'+imageOrg.split('0_FreeCards%2F')[1];
  }

  // 22.10.17 확장자가 없을 경우에만 하드코딩 추가
  var ext = '';
  if(imageOrg.lastIndexOf('.') === -1) {
    ext = extName;
  }

  return '/images/thumb/' + imageOrg + ext;
}*/

export var nftImageUrl = "/images/nftcard.jpg";

export function loadXHR(url) {

  return new Promise(function(resolve, reject) {
      try {
          var xhr = new XMLHttpRequest();
          xhr.open("GET", url);
          xhr.responseType = "blob";
          xhr.onerror = function() {reject("Network error.")};
          xhr.onload = function() {
              if (xhr.status === 200) {resolve(xhr.response)}
              else {reject("Loading error:" + xhr.statusText)}
          };
          xhr.send();
      }
      catch(err) {reject(err.message)}
  });
}

/*
export function isQrCard(name) {
  if (name.startsWith('free')) {
      return false;
  }

  return true;
}*/

/**
 * https://stackoverflow.com/questions/9514179/how-to-find-the-operating-system-details-using-javascript
 * 브라우저/os 데이터 가져오기
 * @returns 
 */
export function getBrowserData() {
  var unknown = '-';
  var result = {browser:"",version:"",os:"",osVersion:""};
  
  // browser
  var nVer = '';
  var nAgt = navigator.userAgent;
  var browser = '';
  var version = '';
  var majorVersion = '';
  var nameOffset, verOffset, ix;

  try {
    // Opera
    if ((verOffset = nAgt.indexOf('Opera')) !== -1) {
        browser = 'Opera';
        version = nAgt.substring(verOffset + 6);
        if ((verOffset = nAgt.indexOf('Version')) !== -1) {
            version = nAgt.substring(verOffset + 8);
        }
    }
    // Opera Next
    if ((verOffset = nAgt.indexOf('OPR')) !== -1) {
        browser = 'Opera';
        version = nAgt.substring(verOffset + 4);
    }
    // Legacy Edge
    else if ((verOffset = nAgt.indexOf('Edge')) !== -1) {
        browser = 'Microsoft Legacy Edge';
        version = nAgt.substring(verOffset + 5);
    } 
    // Edge (Chromium)
    else if ((verOffset = nAgt.indexOf('Edg')) !== -1) {
        browser = 'Microsoft Edge';
        version = nAgt.substring(verOffset + 4);
    }
    // MSIE
    else if ((verOffset = nAgt.indexOf('MSIE')) !== -1) {
        browser = 'Microsoft Internet Explorer';
        version = nAgt.substring(verOffset + 5);
    }
    // Chrome
    else if ((verOffset = nAgt.indexOf('Chrome')) !== -1) {
        browser = 'Chrome';
        version = nAgt.substring(verOffset + 7);
    }
    // Safari
    else if ((verOffset = nAgt.indexOf('Safari')) !== -1) {
        browser = 'Safari';
        version = nAgt.substring(verOffset + 7);
        if ((verOffset = nAgt.indexOf('Version')) !== -1) {
            version = nAgt.substring(verOffset + 8);
        }
    }
    // Firefox
    else if ((verOffset = nAgt.indexOf('Firefox')) !== -1) {
        browser = 'Firefox';
        version = nAgt.substring(verOffset + 8);
    }
    // MSIE 11+
    else if (nAgt.indexOf('Trident/') !== -1) {
        browser = 'Microsoft Internet Explorer';
        version = nAgt.substring(nAgt.indexOf('rv:') + 3);
    }
    // Other browsers
    else if ((nameOffset = nAgt.lastIndexOf(' ') + 1) < (verOffset = nAgt.lastIndexOf('/'))) {
        browser = nAgt.substring(nameOffset, verOffset);
        version = nAgt.substring(verOffset + 1);
        if (browser.toLowerCase() === browser.toUpperCase()) {
            browser = navigator.appName;
        }
    }
    // trim the version string
    if ((ix = version.indexOf(';')) !== -1) version = version.substring(0, ix);
    if ((ix = version.indexOf(' ')) !== -1) version = version.substring(0, ix);
    if ((ix = version.indexOf(')')) !== -1) version = version.substring(0, ix);

    majorVersion = parseInt('' + version, 10);
    if (isNaN(majorVersion)) {
        version = '' + parseFloat(navigator.appVersion);
        majorVersion = parseInt(navigator.appVersion, 10);
    }

    // mobile version
    // var mobile = /Mobile|mini|Fennec|Android|iP(ad|od|hone)/.test(nVer);

    // cookie
    var cookieEnabled = (navigator.cookieEnabled) ? true : false;

    if (typeof navigator.cookieEnabled == 'undefined' && !cookieEnabled) {
        document.cookie = 'testcookie';
        cookieEnabled = (document.cookie.indexOf('testcookie') !== -1) ? true : false;
    }

    // system
    var os = unknown;
    var clientStrings = [
        {s:'Windows 10', r:/(Windows 10.0|Windows NT 10.0)/},
        {s:'Windows 8.1', r:/(Windows 8.1|Windows NT 6.3)/},
        {s:'Windows 8', r:/(Windows 8|Windows NT 6.2)/},
        {s:'Windows 7', r:/(Windows 7|Windows NT 6.1)/},
        {s:'Windows Vista', r:/Windows NT 6.0/},
        {s:'Windows Server 2003', r:/Windows NT 5.2/},
        {s:'Windows XP', r:/(Windows NT 5.1|Windows XP)/},
        {s:'Windows 2000', r:/(Windows NT 5.0|Windows 2000)/},
        {s:'Windows ME', r:/(Win 9x 4.90|Windows ME)/},
        {s:'Windows 98', r:/(Windows 98|Win98)/},
        {s:'Windows 95', r:/(Windows 95|Win95|Windows_95)/},
        {s:'Windows NT 4.0', r:/(Windows NT 4.0|WinNT4.0|WinNT|Windows NT)/},
        {s:'Windows CE', r:/Windows CE/},
        {s:'Windows 3.11', r:/Win16/},
        {s:'Android', r:/Android/},
        {s:'Open BSD', r:/OpenBSD/},
        {s:'Sun OS', r:/SunOS/},
        {s:'Chrome OS', r:/CrOS/},
        {s:'Linux', r:/(Linux|X11(?!.*CrOS))/},
        {s:'iOS', r:/(iPhone|iPad|iPod)/},
        {s:'Mac OS X', r:/Mac OS X/},
        {s:'Mac OS', r:/(Mac OS|MacPPC|MacIntel|Mac_PowerPC|Macintosh)/},
        {s:'QNX', r:/QNX/},
        {s:'UNIX', r:/UNIX/},
        {s:'BeOS', r:/BeOS/},
        {s:'OS/2', r:/OS\/2/},
        {s:'Search Bot', r:/(nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask Jeeves\/Teoma|ia_archiver)/}
    ];
    for (var id in clientStrings) {
        var cs = clientStrings[id];
        if (cs.r.test(nAgt)) {
            os = cs.s;
            break;
        }
    }

    var osVersion = unknown;

    if (/Windows/.test(os)) {
        osVersion = /Windows (.*)/.exec(os)[1];
        os = 'Windows';
    }

    switch (os) {
        case 'Mac OS':
        case 'Mac OS X':
        case 'Android':
          // eslint-disable-next-line
            osVersion = /(?:Android|Mac OS|Mac OS X|MacPPC|MacIntel|Mac_PowerPC|Macintosh) ([\.\_\d]+)/.exec(nAgt)[1];
            break;

        case 'iOS':
          // eslint-disable-next-line
            osVersion = /OS (\d+)_(\d+)_?(\d+)?/.exec(nVer);
            break;
        default :
          osVersion = unknown;
    }
    result.os = os;
    result.browser = browser;
    result.version = version;
    result.osVersion = osVersion;
  } catch (error) {
    console.error(error);
  }
  return result;
}

export function mobileCheck() {
  let check = false;
  // eslint-disable-next-line
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
  return check;
};

/**
 * 수치 증감 기호 표기
 * @param {*} v 
 * @returns 
 */
export function printValueIncreasing(v) {
  if (isBlank(v) || v === 0) {
      return " - ";
  }
  if (v > 0) {
      return `▲${v}`;
  }
  if (v < 0) {
      return `▽${v}`;
  }
}

/**
 * 아이템 종류
 * @author eren (서버코드와 맞춰서 관리중)
 */
export const ItemCategory = {
  // 아이돌 콘텐츠형 아이템 (포카, 포토북 등)
  IDOL_CONTENT : {name: "IDOL_CONTENT", apiPath: "idol-content-items"},
  // 랜덤형 아이템 (다른 종류의 아이템들을 참조하는 형태)
  RANDOM : {name: "RANDOM", apiPath: "random-items"},
  // 선택형 아이템 (다른 종류의 아이템들을 참조하는 형태)
  PICK : {name: "PICK", apiPath: "pick-items"},
  // 권한형 아이템
  AUTHORITY : {name: "AUTHORITY", apiPath: "authority-items"},
  // 포토북미니 아이템
  PHOTOBOOK_MINI : {name: "PHOTOBOOK_MINI", apiPath: "photobook-mini-items"},
  // 포인트충전 아이템
  CHARGE_POINT : {name: "CHARGE_POINT", apiPath: "charge-point-items"},
  // 실물 아이템
  PHYSICAL : {name: "PHYSICAL", apiPath: "physical-items"},
}
Object.freeze(ItemCategory);

/**
 * 권한형 아이템 코드
 * @author eren (서버코드와 맞춰서 관리중)
 */
export const ItemAuthorityCode = [
  {name: "권한 필요없음", description: "아무 권한이 필요하지 않음"},
  {name: "DREAMERS", description: "'Dreamers' 사운드 체크 리허설 영상 시청권"},
  {name: "SAY_MY_NAME", description: "'Say My Name' 사운드 체크 리허설 영상 시청권"},
  {name: "ENCORE", description: "'Dancing Like Butterfly Wings' Encore 영상 시청권"},
  {name: "AFTER_WORK_1_2_3", description: "퇴근일기 DAY 1~3 영상 시청권"}
]

Object.freeze(ItemAuthorityCode);

/**
 * 상점 목록 구분 카타로그
 * @author eren (서버 catalogId 와 맞춰서 관리중)
 */
export const StoreCatalog = {
  PACKAGE : {name : 'pack20040', catalogId : 1, description : "일반 결제 상품 탭"},
  POINT : {name : 'point24011', catalogId : 2, description : "포인트 구매가능 상품 탭"},
  CHARGE : {name : 'pack20041', catalogId : 3, description : "포인트 충전 상품 탭"},
};
Object.freeze(StoreCatalog);

/**
 * 상점 종류 (상품 UI 에 따라 구분되는 종류)
 * @author eren (서버코드와 맞춰서 관리중)
 */
export const ProductCategory = {
  NORMAL: {name: 'NORMAL', description: "일반 상점"},
  PHOTOBOOK_MINI: {name: 'PHOTOBOOK_MINI', description: "포토북 특화 상점"},
}
Object.freeze(ProductCategory);
export const getProductCategory = (str) => {
  return ProductCategory[str];
}

/**
 * 상품 가격 타입
 * @author eren (서버코드와 맞춰서 관리중)
 */
export const ProductPriceType = {
  CASH: {name: 'CASH', description: "현금결제", buttonCss: 'buy'},
  POINT: {name: 'POINT', description: "포인트소모", buttonCss: 'point'},
  FREE: {name: 'FREE', description: "무료", buttonCss: 'free'},
}
Object.freeze(ProductPriceType);
export const getProductPriceType = (str) => {
  return ProductPriceType[str];
}

/**
 * 상품 구매 제한 타입
 * @author eren (서버코드와 맞춰서 관리중)
 */
export const ProductPeriodLimitType = [
  {name: "NONE"}, // 제한 없음
  {name: "PER_USER"}, // 상품별 유저당 구매가능 개수 제한
]
Object.freeze(ProductPeriodLimitType);

/**
 * 상품 재고 타입
 * @author eren (서버코드와 맞춰서 관리중)
 */
export const ProductQuantityType = {
  NONE: {name: 'NONE', description: '제한없음'},
  // NORMAL: {name: 'NORMAL', description: '재고량 제한'}
  DAILY: {name: 'DAILY', description: '일일재고량 제한'},
}
Object.freeze(ProductQuantityType);
export const getProductQuantityType = (str) => {
  return ProductQuantityType[str];
}

/**
 * 쿠폰 사용 결과 코드
 * @author eren (서버코드와 맞춰서 관리중)
 */
export const CouponUseResultCode = {
  OK: {name: 'OK', description: '성공적으로 사용 완료'},
  COMPLETED_BY_ME: {name: 'COMPLETED_BY_ME', description: '본인이 이미 사용했음'},
  COMPLETED_BY_OTHER: {name: 'COMPLETED_BY_OTHER', description: '다른 유저가 이미 사용했음'},
  FAILED: {name: 'FAILED', description: '운영 또는 유효기간 등의 사유로 인해 사용에 실패했음'},
}
Object.freeze(CouponUseResultCode);
export const getCouponUseResultCode = (str) => {
  return CouponUseResultCode[str];
}

/**
 * 유저 로그 타입 (운영툴)
 * @author eren (서버코드와 맞춰서 관리중)
 */
export const UserLogType = {
  LOGIN: {name: 'LOGIN', description: '로그인로그'},
  GAME_START: {name: 'GAME_START', description: '게임시작'},
  GAME_END: {name: 'GAME_END', description: '게임종료'},
  BOARD_READ: {name: 'BOARD_READ', description: '특전영상조회'},
}

/**
 * 유저 포인트 로그 타입 (운영툴)
 * @author eren (서버코드와 맞춰서 관리중)
 */
export const UserPointLogType = {
  SPENT_TO_BUY_PRODUCT: {name: 'SPENT_TO_BUY_PRODUCT', description: '포인트 구매 가능 상품 구입에 소모'},
  SPENT_TO_BUY_GAME_ITEMS: {name: 'SPENT_TO_BUY_GAME_ITEMS', description: '게임 플레이에 소모'},
  SPENT_TO_CHARGE_AP: {name: 'SPENT_TO_CHARGE_AP', description: 'AP 충전에 소모'},
  SPENT_FROM_ADMIN: {name: 'SPENT_FROM_ADMIN', description: '운영자로부터 소모'},
  ACQUIRED_FROM_ITEM: {name: 'ACQUIRED_FROM_ITEM', description: '아이템으로부터 획득'},
  ACQUIRED_FROM_QUEST: {name: 'ACQUIRED_FROM_QUEST', description: '퀘스트로부터 획득'},
  ACQUIRED_FROM_COUPON: {name: 'ACQUIRED_FROM_COUPON', description: '쿠폰으로부터 획득'},
  ACQUIRED_FROM_EXCHANGE_PAPER_POCA: {name: 'ACQUIRED_FROM_EXCHANGE_PAPER_POCA', description: '중복 포카 환급으로 획득'},
  ACQUIRED_FROM_COMPLETE_POCA_INDEX: {name: 'ACQUIRED_FROM_COMPLETE_POCA_INDEX', description: '포카덱스 완성으로 획득'},
  ACQUIRED_FROM_ADMIN: {name: 'ACQUIRED_FROM_ADMIN', description: '운영자로부터 획득'},
}

var moveToLogin;
export const moveToLoginWithRedirect = (isSignup) => {
  moveToLogin(isSignup);
};

function Utils() {
  const navigate = useNavigate();
  
  moveToLogin = (isSignup) => {
    if(isSignup) {
      navigate(`/login?signup=true&redirect_uri=${encodeURIComponent(window.location.pathname + window.location.search)}`);
    } else {
      navigate(`/login?redirect_uri=${encodeURIComponent(window.location.pathname + window.location.search)}`);
    }
  }
  return <></>;
}

export default Utils;

/**
 * 테일윈드 모바일모드인지 체크용 (md 클래스 기준)
 * https://tailwindcss.com/docs/responsive-design
 */
export const isMobileTailWind = ()=>{
  return window.innerWidth <= 768;
}

// 최초 랜더링 제외, 바뀔때만 업데이트 하는 useEffect.
export const useDidMountEffect = (func, deps) => {
  const didMount = useRef(false);
  useEffect(() => {
    if(didMount.current)
      func();
    else
      didMount.current = true;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}

export const useSyncState = (val) => {
  const [state, setState] = useState(val);
  
  const syncValue = useRef();
  syncValue.current = state;
  const setSyncState = (newVal) => {
    syncValue.current = newVal;
    setState(newVal);
  }

  return [state, setSyncState, syncValue];
}

export const useSyncRecoilState = (val) => {
  const [state, setState] = useRecoilState(val);
  
  const syncValue = useRef();
  syncValue.current=state;
  const setSyncState = (newVal) => {
    syncValue.current = newVal;
    setState(newVal);
  }

  return [state, setSyncState, syncValue];
}

export const getCurrencyCode = (countryCode) => {
  switch(countryCode.toUpperCase()) {
    case 'KR' :
      return 'KRW';
    case 'JP' :
      return 'JPY';
    default :
      return 'USD';
  }
}

export const getRawPrice = (currencyCode, price) => {
  switch(currencyCode.toUpperCase()) {
    case 'KRW' :
      return price;
    case 'JPY' :
      return price;
    default :
      return price / 100.0;
  }
}

export const getSafeCurrencyCode = (currencyCode) => {
  switch(currencyCode.toUpperCase()) {
    case 'KRW' :
      return 'KRW';
    case 'JPY' :
      return 'JPY';
    default :
      return 'USD';
  }
}

export const getCurrencySymbol = (currencyCode) => {
  switch(currencyCode.toUpperCase()) {
    case 'KRW' :
      return '₩';
    case 'JPY' :
      return '￥';
    default :
      return '$';
  }
}

export const getPriceByPriceTier = (priceTier, currencyCode) => {
  switch(currencyCode.toUpperCase()) {
    case 'KRW' :
      return priceTier.krw;
    case 'JPY' :
      return priceTier.jpy;
    default :
      return priceTier.usd;
  }
}

export const getRankingText = (rank) => {
  if(rank === 1) {
      return '1st';
  } else if(rank === 2) {
      return '2nd';
  } else if(rank === 3) {
      return '3rd';
  } else if(rank <= 9) {
      return rank + 'th';
  } else {
      return rank;
  }
}

/**
 * 게임별 랭킹 페이지
 */
export const GAME_RANK_PAGE = "gamerankpage";

export const getMinGameItemCount = () => {
  let minItemCount = 0;
  /*
  // [2023.1.6 eren] 설날 이벤트 게임아이템 전체 1개무료
  const now = new Date();
  if (process.env.REACT_APP_ENV_NAME === 'production' || process.env.REACT_APP_ENV_NAME === 'staging') {
      // 2023년 1월 18일 수요일 오전 12:00:00 GMT+09:00 ~ 2023년 1월 28일 토요일 오전 12:00:00 GMT+09:00
      if (now.getTime() >= 1673967600000 && now.getTime() < 1674831600000) {
          minItemCount = 1;
      }
  } else if (process.env.REACT_APP_ENV_NAME === 'devqa' || process.env.REACT_APP_ENV_NAME === 'local') {
      // 2023년 1월 7일 토요일 오전 12:00:00 GMT+09:00 ~ 2023년 1월 8일 일요일 오전 12:00:00 GMT+09:00
      // if (now.getTime() >= 1673017200000 && now.getTime() < 1673103600000) {
          minItemCount = 1;
      // }
  }
  */
  return minItemCount;
}